/*
 * enfoque-redesign.js
 * ---------------------------------------------------------------------------
 * Enfoque product-page repaginação — companion runtime for the redesign layer.
 * Loaded from layout/theme.liquid AFTER theme.js + cart.js (deferred, so it
 * runs after them). Upgrade-safe: a new first-party file, never collides with
 * an upstream Vogal release. See MODIFICATIONS.md §1.
 *
 * Contents:
 *   1. Recent searches ("BUSCAS RECENTES") — the one net-new piece of the
 *      search panel (frame 1g). localStorage-backed; renders clock-icon rows
 *      with a × to remove and a "Limpar" to clear. Everything else in the
 *      search panel is existing theme content, restyled in CSS §8.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* ==== 1. RECENT SEARCHES ============================================== */
  var KEY = 'enf_recent_searches';
  var MAX = 6;

  // Search base path, read from a real form so it honours routes.search_url
  // (locale/root prefix). Falls back to /search.
  function searchBase() {
    var f = document.querySelector('form.search');
    var action = f && f.getAttribute('action');
    return action || '/search';
  }

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
    } catch (e) {
      /* private mode / quota — recent searches just won't persist */
    }
  }

  function add(term) {
    term = (term || '').trim();
    if (!term) return;
    var lower = term.toLowerCase();
    var arr = read().filter(function (t) {
      return String(t).toLowerCase() !== lower;
    });
    arr.unshift(term);
    write(arr);
  }

  function remove(term) {
    write(read().filter(function (t) { return t !== term; }));
  }

  var CLOCK_SVG =
    '<svg class="enf-recent-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/>' +
    '<path d="M12 7.5V12l3 2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render() {
    var recents = read();
    var base = searchBase();
    var boxes = document.querySelectorAll('form.search .enf-recent');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var list = box.querySelector('.enf-recent-list');
      if (!list) continue;
      if (!recents.length) {
        box.hidden = true;
        list.innerHTML = '';
        continue;
      }
      box.hidden = false;
      var html = '';
      for (var j = 0; j < recents.length; j++) {
        var t = recents[j];
        html +=
          '<li class="enf-recent-item">' +
          CLOCK_SVG +
          '<a class="enf-recent-link" href="' + base + '?q=' + encodeURIComponent(t) + '">' + esc(t) + '</a>' +
          '<button type="button" class="enf-recent-remove" data-recent-term="' + esc(t) + '" aria-label="Remover">' +
          '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '</button>' +
          '</li>';
      }
      list.innerHTML = html;
    }
  }

  // Capture the term whenever a search form is submitted.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.search')) return;
    var input = form.querySelector('input[name="q"]');
    if (input) add(input.value);
  });

  // Refresh the list when the panel opens (the theme fades #searchPre in on
  // focusin of the query input).
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('input[name="q"]')) render();
  });

  // Remove one / clear all (delegated — buttons are type="button", no submit).
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.enf-recent-remove');
    if (rm) {
      e.preventDefault();
      remove(rm.getAttribute('data-recent-term'));
      render();
      return;
    }
    if (e.target.closest('[data-clear-recent]')) {
      e.preventDefault();
      write([]);
      render();
    }
  });

  // Initial paint (in case a search field is already focused / present).
  if (document.readyState !== 'loading') render();
  else document.addEventListener('DOMContentLoaded', render);

  /* ==== 2. MOBILE CATEGORY SHEET (frame 1l, Phase 4 #29) ================
   * When the merchant picks the "Creative sheet" mobile category style
   * (settings.mobCatStyle → body.enf-mobcat-sheet), tapping a top-level row
   * in the CATEGORIAS drawer tab (#mobCtnav) opens an immersive sheet built
   * from that category's existing DOM (name, url, subcategory links) instead
   * of the theme's aligned slide. No Liquid/DOM changes — upgrade-safe. The
   * "aligned slide" style (1k) is the theme's default behavior, left as-is
   * and restyled in CSS §9. */
  if (document.body.classList.contains('enf-mobcat-sheet')) {
    var sheet = null;

    function catLabel() {
      var t = document.querySelector('.mnvTtl[href="#mobCtnav"]');
      return t ? t.textContent.trim() : 'Categorias';
    }

    // Category name = the direct text nodes of the row's <a> (skip img/label/arrow).
    function rowName(a) {
      var t = '';
      for (var i = 0; i < a.childNodes.length; i++) {
        if (a.childNodes[i].nodeType === 3) t += a.childNodes[i].textContent;
      }
      t = t.trim();
      return t || a.textContent.trim();
    }

    function imgSrc(img) {
      return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    }

    function ensureSheet() {
      if (sheet) return sheet;
      sheet = document.createElement('div');
      sheet.className = 'enf-cat-sheet';
      sheet.innerHTML =
        '<div class="enf-cat-sheet__hero">' +
          '<button type="button" class="enf-cat-sheet__back">‹ ' + esc(catLabel()) + '</button>' +
          '<div class="enf-cat-sheet__title"></div>' +
        '</div>' +
        '<div class="enf-cat-sheet__body"><p class="enf-cat-sheet__label">Subcategorias</p>' +
          '<div class="enf-cat-sheet__grid"></div></div>' +
        '<a class="enf-cat-sheet__cta" href="#"></a>';
      document.body.appendChild(sheet);
      sheet.querySelector('.enf-cat-sheet__back').addEventListener('click', function () {
        sheet.classList.remove('open');
      });
      return sheet;
    }

    function openFor(a) {
      var s = ensureSheet();
      var li = a.closest('li');
      var sub = li ? li.querySelector('ul.subLinks') : null;
      var name = rowName(a);
      var url = a.getAttribute('href') || '#';
      var heroIcon = a.querySelector('img.icn');

      // Subcategory tiles: direct sublinks, minus the theme's back/"go to" rows.
      var tiles = [];
      if (sub) {
        var items = sub.querySelectorAll(':scope > li');
        for (var i = 0; i < items.length; i++) {
          var liEl = items[i];
          if (liEl.classList.contains('backto')) continue;
          var link = liEl.querySelector(':scope > a');
          if (!link || !link.getAttribute('href')) continue;
          var ic = link.querySelector('img.icn');
          tiles.push(
            '<a class="enf-cat-sheet__tile" href="' + link.getAttribute('href') + '">' +
            (ic ? '<img class="enf-tile-ic" src="' + esc(imgSrc(ic)) + '" alt="">' : '') +
            '<span>' + esc(rowName(link)) + '</span></a>'
          );
        }
      }

      s.querySelector('.enf-cat-sheet__title').innerHTML =
        (heroIcon ? '<img class="enf-cat-sheet__icon" src="' + esc(imgSrc(heroIcon)) + '" alt="">' : '') +
        '<div><h3>' + esc(name) + '</h3>' +
        (tiles.length ? '<span class="enf-cat-sheet__count">' + tiles.length + ' subcategorias</span>' : '') +
        '</div>';
      s.querySelector('.enf-cat-sheet__grid').innerHTML = tiles.join('');
      var cta = s.querySelector('.enf-cat-sheet__cta');
      cta.setAttribute('href', url);
      cta.textContent = 'Ver tudo em ' + name;
      // reflow so the transform transition runs from the closed state
      void s.offsetWidth;
      s.classList.add('open');
    }

    // Capture phase on document → runs before the theme's element-bound
    // `.mobNav .hasSub` click handler, and stopPropagation keeps that handler
    // (the aligned slide) from also firing. Only top-level #mobCtnav rows.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#mobCtnav')) return;
      var a = e.target.closest('a.hasSub');
      if (!a) return;
      var li = a.parentElement;
      if (!li || !li.parentElement || li.parentElement.id !== 'mobCtnav') return;
      e.preventDefault();
      e.stopPropagation();
      openFor(a);
    }, true);
  }
})();
